import { useEffect } from "react";
import { useGetUsersQuery } from "../../redux/features/dummySlice/dummyApiSlice";
import { Controller, useForm } from "react-hook-form";
import "./modules.css";

import { signupResolver } from "validators/UserValidation";

function ExampleRoute() {
  const { data, isLoading, isSuccess } = useGetUsersQuery(null);

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: signupResolver,
    defaultValues: { email: "", name: "", password: "" },
  });

  const onSubmit = (event) => {
    event.preventDefault();
  };

  return (
    <div className="App">
      <h1 className="text-3xl text-black-700 py-3 px-2">
        {" "}
        Register to K9 Example
      </h1>
      <div className="w-40 mx-5">
        <form>
          <h1> Email </h1>
          <Controller
            control={control}
            name="email"
            render={({ field: { onChange, value } }) => (
              <input
                type="text"
                value={value}
                placeholder="Enter your email"
                onChange={onChange}
                className=" h-44px p-2 rounded-lg border border-solid border-gray-300 p-10px 14px 10px 14px gap-8 text-gray-700 bg-white"
              />
            )}
          />

          {errors?.email?.message && (
            <h1 className="text-red-300"> {errors?.email?.message} </h1>
          )}

          <h1> Password </h1>

          <Controller
            control={control}
            name="password"
            render={({ field: { onChange, value } }) => (
              <input
                type="text"
                value={value}
                placeholder="Enter your password"
                onChange={onChange}
                className=" h-44px p-2 rounded-lg border border-solid border-gray-300 p-10px 14px 10px 14px gap-8 text-gray-700 bg-white"
              />
            )}
          />

          {errors?.password?.message && (
            <h1 className="text-red-300"> {errors?.password?.message} </h1>
          )}

          {/* <h1> Password </h1>

          <input
            onChange={(val) => setFormData({ ...formDate, name: val })}
            type="text"
            placeholder="Enter your password"
            className=" h-44px p-2 rounded-lg border border-solid border-gray-300 p-10px 14px 10px 14px gap-8 text-gray-700 bg-white"
          /> */}

          <button className="gradient-button" onClick={handleSubmit(onSubmit)}>
            Register Member
          </button>
        </form>
      </div>
      <div className="my-5 mx-5">
        <h1 className="text-2xl text-black-500 my-2 "> Member Data </h1>
        {isLoading && <span>Loading...</span>}
        {isSuccess &&
          data?.map((user) => <h2 key={Math.random()}>{user.name}</h2>)}
        {data?.map((user) => (
          <h2 key={Math.random()}>{user.name}</h2>
        ))}
      </div>
    </div>
  );
}
export default ExampleRoute;
